<template>
  <draggable class="dragArea list-group" :v-model="list" :class="draggableClass">
    <div v-for="(item, index) in list" :key="index" class="list-group-item" :class="wrapperClass">
      <slot :item="item" :index="index"></slot>
    </div>
  </draggable>
</template>

<script>

import { VueDraggableNext } from 'vue-draggable-next'

export default {
  name: "RpmDraggable",
  components: {
    draggable: VueDraggableNext,
  },
  props: {
    list: {
      type: Array,
      required: true
    },
    draggableClass: {
      type: String,
      default: "",
    },
    wrapperClass: {
      type: String,
      default: "",
    }
  },
};
</script>
